/**
 *
 * Top Left Nav Bar Tabs
 *
 */
import React from 'react';

import { Box, Center } from '@chakra-ui/react';
import { useFlags } from '@flagsmith/flagsmith/react';
import map from 'lodash/map';
import { useLocation } from 'react-router-dom';

import { FilterComponent } from 'components/FilterView';
import MenuItem from 'components/Navigation/MenuItem';
import { routeConfig } from 'hooks/RouteConfig/routeConfig';

import { selectedTabStyles, tabStyles } from '../styles';
import { getMainMenuItems } from '../utils';

interface Props {}

export const LeftComponent: React.FC<Props> = props => {
  const current = useLocation().pathname;
  const { jit_feature: jitEnabled } = useFlags(['jit_feature']);
  const isJitEnabled = jitEnabled?.enabled === true;

  return (
    <>
      {map(getMainMenuItems(isJitEnabled), each => {
        const isJit = each.url === '/jit';
        const storedSubMenu = localStorage.getItem([each.url] + '-top-nav-bar');
        const secondaryNav =
          routeConfig[each.key as keyof typeof routeConfig]?.navBar;
        const hasValidSubMenu = secondaryNav?.list.some(
          item => item.url === storedSubMenu,
        );
        const subMenu = hasValidSubMenu ? storedSubMenu : undefined;
        const path = isJit && !subMenu ? `${each.url}/setup` : each.url;
        return (
          <FilterComponent
            filterPath={`${each.url}`}
            key={`${each.url}-${each.key}-topNavBar`}
          >
            <MenuItem
              url={path + (subMenu ? subMenu : '')}
              badge={each?.badge}
              badgeTop="0px"
              badgeLeft={each?.badgeLeft}
              {...tabStyles}
              // Match on an exact path or a segment boundary; a plain
              // prefix check also highlighted siblings like /dashboard-x.
              selected={
                current === each.key ||
                current.startsWith(`${each.key}/`) ||
                (current === '/' && each.key === '/dashboard')
              }
              selectedStyles={selectedTabStyles}
            >
              <Center h="full" p={0}>
                <Box fontSize="navBarHeader">{each.title}</Box>
              </Center>
            </MenuItem>
          </FilterComponent>
        );
      })}
    </>
  );
};
